import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { getSiteSeparationWithDefaults } from './siteSeparationDefaults';

type SiteSeparationNeighborshipFieldValues = {
  siteSeparationNeighborshipEnabled: boolean;
};

export const siteSeparationNeighborship: FormSnippet<
  DiscoverySettingsObject,
  SiteSeparationNeighborshipFieldValues
> = {
  render: ({ form }) => (
    <FormSwitch
      control={form.control}
      name='siteSeparationNeighborshipEnabled'
      label='Try to assign devices without sites based on device neighborship'
      description='If enabled, this rule will be run after all other rules listed below.'
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.siteSeparationNeighborshipEnabled =
      model.siteSeparation?.neighborshipFallbackEnabled ?? true;
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.siteSeparation = {
      ...getSiteSeparationWithDefaults(modelDraft.siteSeparation),
      neighborshipFallbackEnabled:
        transformedValues.siteSeparationNeighborshipEnabled,
    };
  },
  schema: z.object({
    siteSeparationNeighborshipEnabled: z.boolean(),
  }),
};
